//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum UserRoles {
    User = 1,
    Admin = 2,
    Guest = 3,
    Initial = 4,
    ProjectsAdministrator = 5,
}
